import { useState, useEffect } from "react";

const DJANGO_API = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export function useShopifyProducts(categoryFilter = null) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    async function fetchProducts() {
      setLoading(true);
      setError(null);
      try {
        let url = `${DJANGO_API}/shop/products/`;
        if (categoryFilter) {
          url += `?category=${encodeURIComponent(categoryFilter)}`;
        }
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();
        setProducts(data.products || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchProducts();
  }, [categoryFilter]);

  return { products, loading, error };
}

export function useShopifyCategories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${DJANGO_API}/shop/categories/`)
      .then(r => r.json())
      .then(data => setCategories(data.categories || []))
      .catch(() => setCategories([]));
  }, []);

  return categories;
}